import React from 'react';
import defaultConnect from '../../../../components/redux/defaultConnect';
import makeRequest from '../../../../lib/apiService';
import Table from '../../../../components/table/table';
import Confirmacion from '../../../../components/confirmacion/confirmacion';
import ModalVehiculo from './modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

const defaultFilters = {
  search: '',
};

class VehiculosAsignados extends React.Component {
  state = {
    tabla: {
      rows: [],
      total: 0,
      activePage: 1,
      size: 10,
    },
    confirmation: {
      show: false,
      message: '',
      accept: f => f,
      acceptParams: {},
    },
    modal: {
      show: false,
    },
    filters: defaultFilters,
  };

  componentDidMount() {
    this.getData();
  }

  getData = async (page = 1) => {
    const { tabla: { size }, filters } = this.state;
    const { setLoading, pushError, id } = this.props;

    try {
      setLoading(true);
      const resp = await makeRequest(
        'vehicles/?limit=99999',
        { method: 'GET' },
      );

      let filtered = resp.rows.filter(v => String(v.id_driver) === String(id));

      if (filters.search) {
        const q = filters.search.toLowerCase();
        filtered = filtered.filter(v =>
          (v.key_vehicle && v.key_vehicle.toLowerCase().includes(q))
          || (v.plate_number && v.plate_number.toLowerCase().includes(q))
          || (v.description && v.description.toLowerCase().includes(q))
        );
      }

      const total = filtered.length;
      const start = (page - 1) * size;
      const rows = filtered.slice(start, start + size);

      this.setState((prevState) => ({
        tabla: {
          ...prevState.tabla,
          rows,
          total,
          activePage: page,
        }
      }), () => { setLoading(false); });
    } catch (error) {
      setLoading(false);
      pushError(error.message);
    }
  }

  handleFilterChange = ({ target: { name, value } }) => {
    this.setState(
      (prevState) => ({
        tabla: { ...prevState.tabla, activePage: 1 },
        filters: { ...prevState.filters, [name]: value },
      }),
      this.getData,
    );
  }

  clearFilters = () => {
    this.setState({ filters: defaultFilters }, this.getData);
  }

  paginationHandler = (event, value) => {
    const { tabla, tabla: { activePage } } = this.state;

    switch (event) {
      case 'page': {
        let pagina = value;
        if (pagina === 'prev') pagina = activePage - 1;
        else if (pagina === 'next') pagina = activePage + 1;
        this.getData(pagina);
        break;
      }
      case 'size':
        this.setState({ tabla: { ...tabla, size: parseInt(value, 10) } }, () => {
          this.getData(activePage);
        });
        break;
      default: break;
    }
  }

  toggleConfirmation = (confirmation) => this.setState((prevState) => ({
    confirmation: {
      ...prevState.confirmation,
      ...confirmation,
      show: !prevState.confirmation.show,
    },
  }));

  deleteConfirmation = (vehicle) => this.toggleConfirmation({
    message: `El vehículo ${vehicle.key_vehicle} ya no estará vinculado al chofer.`,
    accept: this.deleteVehiculo,
    acceptParams: { vehicle },
  });

  deleteVehiculo = async () => {
    const { setLoading, pushError, pushSuccess } = this.props;
    const {
      tabla: { activePage },
      confirmation: { acceptParams: { vehicle } },
    } = this.state;

    try {
      this.toggleConfirmation();
      setLoading(true);
      await makeRequest(
        `vehicles/${vehicle.id_vehicle}`,
        { method: 'PUT' },
        {
          key_vehicle: vehicle.key_vehicle,
          imei: vehicle.imei,
          phone_number: vehicle.phone_number,
          plate_number: vehicle.plate_number,
          description: vehicle.description,
          notes: vehicle.notes,
          id_user: vehicle.id_user,
          id_driver: null,
        },
      );
      setLoading(false);
      pushSuccess('Se ha realizado el cambio con éxito.', 3000);
      this.getData(activePage);
    } catch (error) {
      setLoading(false);
      pushError(error.message);
    }
  }

  openModal = () => this.setState((prevState) => ({
    modal: { ...prevState.modal, show: true },
  }));

  closeModal = () => this.setState({ modal: { show: false } });

  render() {
    const { tabla, filters, confirmation, modal } = this.state;
    const { id } = this.props;
    const columns = ['Clave', 'Placas', 'Descripción', 'Opciones'];

    const rows = tabla.rows.map(row => ({
      key: row.key_vehicle,
      plates: row.plate_number,
      description: row.description,
      options: row,
    }));

    const configTable = {
      columnDef: {
        options: val => (
          <button type="button" className="btn btn-sm btn-danger" onClick={() => { this.deleteConfirmation(val); }}>
            <FontAwesomeIcon icon={faTrash} />
          </button>
        ),
      },
      columnStyle: {
        options: { whiteSpace: 'nowrap', textAlign: 'right' },
      },
    };

    return (
      <>
        <div className="vehiculos-asignados card mirai-shadow">
          <div className="card-header va-header">
            <span>Vehículos asignados</span>
            <button type="button" className="btn btn-sm btn-asignar" onClick={this.openModal}>
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '0.4rem' }} />
              Asignar vehículo
            </button>
          </div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-12 col-md-5">
                <div className="input-group chofer-search-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text chofer-search-addon">
                      <FontAwesomeIcon icon={faSearch} />
                    </span>
                  </div>
                  <input
                    type="text"
                    name="search"
                    className="form-control chofer-search-input"
                    placeholder="Buscar por clave o placas..."
                    value={filters.search}
                    onChange={this.handleFilterChange}
                    autoComplete="off"
                  />
                  {filters.search && (
                    <div className="input-group-append">
                      <button type="button" className="btn chofer-search-clear" onClick={this.clearFilters}>
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Table
              columns={columns}
              data={rows}
              configTable={configTable}
              pagination={{
                total: tabla.total,
                page: tabla.activePage,
                limit: tabla.size,
              }}
              paginationEvent={this.paginationHandler}
              updateTable={() => { this.getData(tabla.activePage); }}
              tableClass="datatable-wrapper"
            />
          </div>
        </div>

        {modal.show && (
          <ModalVehiculo closeModal={this.closeModal} id={id} idUser={this.props.idUser} updateTable={this.getData} />
        )}
        {confirmation.show && (
          <Confirmacion
            message={confirmation.message}
            accept={confirmation.accept}
            cancel={() => { this.toggleConfirmation(undefined); }}
          />
        )}
      </>
    );
  }
}

export default defaultConnect(VehiculosAsignados);
